import { render } from "./AuthImage.vue?vue&type=template&id=52f6c34c"
import script from "./AuthImage.vue?vue&type=script&lang=js"
export * from "./AuthImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__